module.exports = __webpack_public_path__ + "clock.svg?393369d39a647504f930ed599417cba4";